const coalesceWithEmptyString = (
  value: string | null | undefined,
): string => value ?? '';

export default coalesceWithEmptyString;
